import { getNumberOfNights } from '../util/dataLayer';

const INSTANT_BOOKING_FEATURE_VALUE = 'instantBooking';

export function calculateNumberOfNights(houseData: {
    arrivalDate: string;
    departureDate: string;
}): number | null {
    const arrivalDate = new Date(houseData.arrivalDate);
    const departureDate = new Date(houseData.departureDate);

    if (Number.isNaN(arrivalDate.getTime()) || Number.isNaN(departureDate.getTime())) {
        return null;
    }

    return getNumberOfNights(arrivalDate, departureDate);
}

export function hasInstantBooking(features: string[]): boolean {
    return features.includes(INSTANT_BOOKING_FEATURE_VALUE);
}

export function calculatePricePerNight(price: number, numberOfNights: number): number {
    if (numberOfNights === 0) {
        return price;
    }

    return Number((price / numberOfNights).toFixed(2));
}

export function calculateValue(pricePerNight: number, numberOfNights: number): number {
    return Number((pricePerNight * numberOfNights).toFixed(2));
}
